/**
 * Default chart colors utility
 * Uses the application's CSS variables for consistent theming
 */

/**
 * Get default chart colors from CSS variables
 * @returns Array of default chart colors
 */
export const getDefaultChartColors = (): string[] => {
  // Get computed styles to access CSS variables
  const computedStyle = getComputedStyle(document.documentElement);

  // Return an array of chart colors from the CSS variables
  return [
    /*     computedStyle.getPropertyValue('--ks-chart-green-bluish').trim(),
    computedStyle.getPropertyValue('--ks-chart-bluish').trim(),
    computedStyle.getPropertyValue('--ks-chart-cyanish').trim(),
    computedStyle.getPropertyValue('--ks-chart-purple').trim(),
    computedStyle.getPropertyValue('--ks-chart-deep-purple').trim(),
    computedStyle.getPropertyValue('--ks-chart-orangish').trim(),
    computedStyle.getPropertyValue('--ks-chart-redish').trim(),
    computedStyle.getPropertyValue('--ks-chart-yellowish').trim(), */
    // Add solid variants for more color options
    computedStyle.getPropertyValue('--ks-chart-bluish-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-purple-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-orangish-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-cyanish-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-deep-purple-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-redish-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-yellowish-solid').trim(),
    computedStyle.getPropertyValue('--ks-chart-green-bluish-solid').trim(),
  ];
};

/**
 * Assign default colors to series that don't have colors defined
 * @param series Array of series data
 * @returns The same series with colors assigned
 */
export const assignDefaultColors = <T extends { color?: string }>(series: T[]): T[] => {
  const defaultColors = getDefaultChartColors();

  return series.map((item, index) => {
    // Only assign a color if one isn't already defined
    if (!item.color) {
      return {
        ...item,
        color: defaultColors[index % defaultColors.length],
      };
    }
    return item;
  });
};
